export default __webpack_public_path__ + "static/media/Status.ceb23c4e.png";